module.exports = __webpack_public_path__ + "img/zjtx.45269728.png";